import { LaborProductivityDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/store/laborProductivityDashboard.store.types';

export const LABOR_PRODUCTIVITY_DATA_LOCKED_STUB: Partial<LaborProductivityDashboardStore> = {
  activeMembersByPosition: [
    { position: 'Resident Care Partner (PSW)', count: 1480 },
    { position: 'Server', count: 477 },
    { position: 'Medication Care Partner', count: 261 },
    { position: 'Wellness Nurse', count: 251 },
    { position: 'Housekeeper', count: 195 },
    { position: 'Concierge', count: 167 },
    { position: 'Cook', count: 140 },
    { position: 'Life Enrichment Assistant', count: 92 },
    { position: 'Dishwasher', count: 68 },
    { position: 'Culinary Floor Attendant', count: 45 },
    { position: 'Maintenance Assistant', count: 22 },
  ],
  calloutShiftsByType: [
    { type: 'Casual', count: 475, percentage: 51.63 },
    { type: 'Part Time', count: 206, percentage: 22.41 },
    { type: 'Flex', count: 129, percentage: 14 },
    { type: 'Full Time', count: 110, percentage: 11.96 },
  ],
  releasedShiftsByEmployee: [
    { name: 'Olanike Bamimore', count: 5 },
    { name: 'Kgalalelo Msipha', count: 4 },
    { name: 'Rose Mary Jacob', count: 3 },
    { name: 'Janet Davis', count: 3 },
    { name: 'Claudine Irumva', count: 2 },
    { name: 'Pierette Nyenyezi', count: 2 },
    { name: 'Jacqueline Vicente', count: 2 },
    { name: 'Samir Bhandari', count: 2 },
    { name: 'Marvelous Isibor', count: 1 },
    { name: 'Newlyn Everly Benavides', count: 1 },
    { name: 'Maureen Namaggwa', count: 1 },
    { name: 'Sukhdeep Kaur', count: 1 },
  ],
};
